<template>
  <div class="tkEdit full-height linear-main3">
    <ld-header
      transparent
      white
    >
      {{ tkSearchInfo.depport.cityName }}
      <van-icon
        v-show="flights.length > 1"
        name="exchange"
      />
      <span v-show="flights.length == 1">⇀</span>
      {{ tkSearchInfo.arrport.cityName }}
    </ld-header>

    <div class="tkEditwrapper">
      <mescroll-vue
        ref="mescroll"
        :down="down"
      >
        <div class="box">
          <travel-tips :city-id="tkSearchInfo.arrport.cityId"/>

          <!-- 行程 -->
          <div
            v-for="(info, index1) in flights"
            :key="index1"
            class="bg-white borderRadius overflow"
            @click.stop="showPlanes = true"
          >
            <van-cell
              :border="false"
              is-link
            >
              <div>
                <van-tag
                  class="tag-green"
                  round
                >
                  <span v-show="index1 == 0 && flights.length > 1">{{ $t('C174', '去程') }}</span>
                  <span v-show="index1 == 0 && flights.length == 1">{{ $t('C101', '单程') }}</span>
                  <span v-show="index1 == 1">{{ $t('C175', '返程') }}</span>
                </van-tag>
                <span class="font14 font">
                  {{ info.departDate }} {{ info.departDate | week }}&nbsp;{{
                    info.departTime
                  }}&nbsp;{{
                    info.cabin.cabinName
                  }}
                </span>

                <span v-show="showProductTypeTips">
                  <van-tag
                    v-if="'' != showFirstProductTypeColor && (info.flightMinPrice == info.price.minPrice)"
                    :color="showFirstProductTypeColor"
                  >
                    {{ showFirstProductTypeText }}
                  </van-tag>
                  <van-tag
                    v-else-if="info.price.checkJs = 0"
                    :color="info.price.tagColor"
                  >{{ info.price.tagText }}</van-tag>
                  <van-tag
                    v-else-if="info.price.checkJs = 1"
                    :color="info.price.tagColor"
                  >{{ info.price.tagText }}</van-tag>
                  <van-tag
                    v-else-if="info.price.checkJs = 2"
                    :color="info.price.tagColor"
                  >{{ info.price.tagText }}</van-tag>
                  <van-tag
                    v-else
                    v-show="info.price.productType && info.price.productType != 1 && info.price.productType != 6 "
                    :color="info.price.productType | productTypeColor"
                  >
                    {{ info.price.productType | productType }}
                  </van-tag>
                  &nbsp;

                </span>

                <div class="deep-gray font12">
                  {{ info.departAirportName }}&nbsp;{{ info.departTerminal }} - {{
                    info.arriveAirportName
                  }}&nbsp;{{ info.arriveTerminal }}
                </div>
                <div
                  v-show="info.sharFlightNo"
                  class="gray font12"
                >
                  实际乘坐：{{ info.sharFlightNo }}请按实际乘坐航班办理值机。
                </div>
              </div>
              <div class="main-color font12">
                <span @click.stop="toggle('rule', info)">{{ $t('F010', '退改签规则') }}</span>
              </div>
            </van-cell>
          </div>

          <!--出行人 -->
          <traver
            :person-list="tkSearchInfo.ccsqd.personList"
            :title="$t('C001', '乘机人')"
            :traveler-list="travelerList"
            class="borderRadius overflow"
            element=".tkEdit"
            @selected="initPrice"
          />
          <!-- 海航会员注册 -->
          <van-cell v-if="showmember" style=" padding-bottom: 2px;">
            <van-row>
              <van-checkbox class="font14" icon-size="12px" v-model="checkedregist" shape="round">
                <h4 class="h4title">海航会员注册</h4>
              </van-checkbox>
            </van-row>
            <div class="marin_4px">
              <div class="font12">所有乘机人统一注册为海航会员</div>
              <div class="font11c">*已是航司会员的用户不会重复注册</div>
            </div>
          </van-cell>
          <!-- 保险  -->
          <insurance
            ref="insurance"
            :cxrlength="travelerList.length"
            class="borderRadius overflow"
            element=".tkEdit"
            @selected="checkBxList"
          />

          <!-- 服务费 -->
          <van-cell
            v-if="!isYlslh5"
            :title="$t('E001', '服务费')"
            class="borderRadius overflow"
          >
            <div>
              <span class="font16 red"><small>&yen;</small> {{ serviceFee }}</span>*{{
                travelerList.length
              }}人
            </div>
          </van-cell>
          <!-- 差旅信息 -->
          <travel-info
            v-show="tkSearchInfo.queryStr.tripType == 1"
            ref="travelinfo"
            class="borderRadius overflow"
            element=".tkEdit"
            @selected="getTavelInfo"
          />
          <!-- 接送机信息 -->
          <!-- v-if="Selfservice" -->
          <transfer-info
            ref="transferinfo"
            class="borderRadius overflow"
            :flights="flights"
            @carnumber="carnumber"
            @picksenddaea="picksenddaea"
            @fillshow="fillshow"
            v-if="Selfservice"
          />

          <!-- 联系信息 -->
          <div class="borderRadius overflow">
            <van-field
              :label="$t('D022', '联系信息')"
              :readonly="true"
              is-link
              @click="$refs['linker'].toggle()"
            >
              <div slot="input">
                {{ linker.linkMan }} ({{ linker.linkTel || linker.linkMobile }})

                <div
                  v-if="!isYlslh5"
                  v-show="yc"
                  class="font12 gray"
                >
                  {{ $t('D020', '邮箱') }} ({{ linker.linkEmail }})
                </div>
              </div>
            </van-field>
          </div>

          <!-- 编辑联系人 -->
          <ld-edit-linker
            ref="linker"
            :data="linker"
            @selected="getLinker"
          />

          <div
            v-if="false"
            v-show="this.sl"
            class="font12 gray pad-b-20"
          >
            点击“提交订单”表示已阅读锂电池规定、禁止危险品乘机说明、{{ loginConfig.pageName }}购票须知。
          </div>

          <!-- 协议 -->
          <div
            v-show="this.ysf || this.springdata"
            class="agreementBox flex-h background-white pad10 padt10 FF"
          >
            <div class="checkClass">
              <van-checkbox
                v-model="agrChecked"
                icon-size="16px"
                shape="square"
              />
            </div>
            <div class="agreementBox-main flex-1 ft-12 padl10 ">
              <span>{{ tiptext }}</span>
              <span
                v-for="(item, index) in agreeArr"
                :key="index"
                class="colorBlue"
                @click="clickAgree(item, index)"
              >
                {{ item.name }}
                <i v-if="index != agreeArr.length - 1">、</i>
              </span>
              <!-- <br> -->
              <span>{{ contenttext }}</span>
            </div>
          </div>
        </div>
      </mescroll-vue>
      <!-- 协议文本弹出 -->
      <van-popup
        v-model="agreeShow"
        :style="{ height: '94%' }"
        class="flex-v agreeCom"
        close-icon="close"
        close-icon-position="top-right"
        closeable
        get-container="body"
        position="bottom"
        safe-area-inset-bottom
      >
        <agreementTextCom :agree-tit="agreeTit"/>
      </van-popup>
    </div>
    <!-- 底部导航 -->
    <ld-tabbar
      ref="tabbar"
      :price-list="priceList"
    >
      <van-row
        align="center"
        class="bg-white full-width shadow"
        justify="space-between"
        type="flex"
      >
        <van-col span="1"/>
        <van-col span="7">
          <span class="font12 money-color">&yen;</span><span class="font22 money-color">{{ totalPrice
          }}</span>
          <span class="font10 gray">{{ $t('E017', '共') }}{{ travelerList.length }}人</span>
        </van-col>
        <van-col span="8">
          <div
            class="font12 text-left"
            @click="toggle('tabbar')"
          >
            <span>{{ $t('E006', '明细') }}</span>
            <van-icon
              class="vertical-middle"
              name="arrow-up"
              size="14"
            />
          </div>
        </van-col>
        <van-col
          class="pad-r-8"
          span="8"
        >
          <ld-button
            :disabled="dissa"
            :loading="false"
            main
            size="md"
            @click.native="book"
          >
            {{ $t('F560', '提交订单') }}
          </ld-button>
        </van-col>
      </van-row>
    </ld-tabbar>


    <!-- 退改规则 -->
    <refund-change-rule
      ref="rule"
      :obj="changeRule"
      cplx="10901"
    />


    <!-- 行程展示 -->
    <van-popup
      v-model="showPlanes"
      :close-on-popstate="true"
      class="popup-width"
    >
      <voyage :flights="flights" :show-cabin="true"/>
    </van-popup>


    <!-- 预留改签提示 -->
    <van-dialog
      v-model="showReserved"
      :confirm-button-text="$t('B012', '继续预订')"
      :title="$t('C474', '提示')"
      show-cancel-button
      @cancel="showReserved = false"
      @confirm="sendAjax"
    >
      <van-cell>
        <div
          v-for="(info, index2) in reservedData"
          :key="index2"
          class="text-indent"
        >
          {{ $t('Q510', '乘客') }} <span class="orange">{{ info.psgName }}</span>
          <van-tag
            v-show="info.fsEmpId"
            type="warning"
          >
            {{ $t('attach', '附') }}
          </van-tag>
          {{ $t('There', '存在预留改签的机票； 行程：') }}<span>{{ info.voyageZh }}</span>， {{ info.departTime }}， {{
            info.flightNo
          }}，可联系客服进行改签!
        </div>
      </van-cell>
    </van-dialog>
    <!-- 点击订单提交最后弹窗信息 -->
    <van-dialog class="custom_dialog" v-model="submitted" title="乘机人信息" :showConfirmButton=false>
      <!-- <van-call> -->
      <div style="margin:10px 10px">
        <div class="tilti_info">
          航班信息
        </div>
        <div v-for="(info,index1) in flights" :key="info.cacheId" class="font14 deep-gray" >
          <div class="marg_bott">
            <van-tag
              class="tag-green"
              style="margin-right: 5px;"
              round
            >
              <span v-show="index1 == 0 && flights.length > 1">{{ $t('C174', '去程') }}</span>
              <span v-show="index1 == 0 && flights.length == 1">{{ $t('C101', '单程') }}</span>
              <span v-show="index1 == 1">{{ $t('C175', '返程') }}</span>
            </van-tag>
            <span>{{ info.departCityName }}{{ info.departAirportName }}{{ info.departTerminal }}-{{ info.arriveCityName }}{{ info.arriveAirportName }}{{ info.arriveTerminal }}</span>
          </div>
          <div class="marg_bott marg_left">
            <span>{{ info.airlineName }}{{ info.flightNo }}</span>
            <!-- <span class="font_left">￥{{ info.salePrice }}</span> -->
          </div>
          <div class="marg_bott marg_left">
            <span>{{ info.departDate }}&nbsp;{{ info.departTime }}</span> &nbsp;至&nbsp;
            <span> {{ info.arriveDate }}&nbsp;{{ info.arriveTime }}</span>
          </div>
        </div>
      </div>
      <div class="color-bartow"/>

      <!-- </van-call> -->

      <div class="tilti_info" style="margin: 10px 10px;">乘机人</div>
      <div v-for="(item,index) in travelerList" :key="item.empId">
        <div style="margin: 10px 10px ;">
          <div class="custom_css">
            <span class="custom_tili">姓名:</span>{{ item.chName || item.empName }}
          </div>
          <div class="custom_css">
            <span class="custom_tili">手机号:</span>{{ item.phoneNumber }}
          </div>
          <div class="custom_css">
            <span
              class="custom_tili">{{ item.cardName }}{{ (item.cardType == 'HX' || item.cardType == 'JR' || item.cardType == 'TB') ? '证' : '' }}信息:</span>{{ item.cardNo
            }}
          </div>
        </div>
        <div class="color-bar linear-main1" v-if="travelerList.length>0 && travelerList.length!=index+1 "/>

      </div>
      <!-- <div class="button_css" >
        <div>
        <van-button class="button_height linear-main1 "  type="primary" size="normal" @click="submitted=false">取消</van-button>
        <van-button class="button_height linear-main1 "  type="primary" size="normal" @click="buttconfirmed">确认</van-button>
          </div>
      </div> -->
      <div
        style="margin: 10px;"
        class="text-right"
      >
        <van-button
          size="normal"
          @click="submitted=false"
          style="height:36px"
          type="primary"
        >
          {{ $t('B008', '取消') }}
        </van-button>
        &nbsp;
        <van-button
          style="height:36px"
          size="normal"
          type="info"
          @click="buttconfirmed"
        >
          {{ $t('B006', '确定') }}
        </van-button>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import {Cell, Checkbox, CheckboxGroup, Dialog, Field, Popup, Tag, Button} from 'vant'
import {mapGetters} from 'vuex'
import ldEditLinker from 'Components/ldEditLinker'
import MescrollVue from 'mescroll.js/mescroll.vue'
import ldHeader from 'Common/ldHeader'
import travelInfo from 'Components/travelInfo'
import transferInfo from 'Components/transferinfo'
import insurance from 'Components/insurance'
import refundChangeRule from 'Components/refundChangeRule'
import voyage from 'Components/tk/voyage'
import traver from 'Components/tk/traver'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import ldButton from 'Common/ldButton'
import {getIdNumber, getIdType, getName} from 'Utils/publicFun'
import orderMixin from '@/business/views/Home/allorder/components/orderMixin'
import travelTips from 'Components/travelTips'
import {getSysType} from 'CommonUtils/plus.js'
import {validators} from 'Utils/valid'
import defaultMixin from '@/business/mixins/default'
import agreementTextCom from '@/business/components/agreement/agreementText.vue'
import {queryVipParameter, getParameter, getParListByCodes} from 'Utils/publicApi'
import { isGat } from 'Utils/gattools';

export default {
  name: 'TkEdit',
  mixins: [orderMixin, defaultMixin],
  components: {

    ldHeader,
    travelInfo,
    transferInfo,
    [Cell.name]: Cell,
    [Tag.name]: Tag,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    insurance,
    refundChangeRule,
    voyage,
    traver,
    ldTabbar,
    ldButton,
    ldEditLinker,
    MescrollVue,
    travelTips,
    agreementTextCom
  },
  data() {
    return {
      cache: [],
      ctsf: '',
      crsf: '',
      ertbx: 0,
      crbx: 0,
      list: [],
      Price: 0,//价格.
      length: 0,
      selectedCoupon: -1,
      ticPirce: 0, //机票价格
      coupon: {}, // 优惠劵对象
      couponShow: false,
      check: [],
      dissa: false,
      tre: true,
      yc: false,
      ysf: false,
      sl: false,
      show: false,
      agrChecked: false, //是否同意协议
      agreeShow: false, //协议是否弹出
      agreeTit: '', //协议的tit
      down: {use: false},
      showPlanes: false,
      showPrice: false,
      showReserved: false,
      priceList: [],
      changeRule: {},
      travelInfo: {},
      linker: {
        linkMan: '',
        linkTel: '',
        linkEmail: ''
      },//联系人信息
      bxPrice: 0,
      reservedData: [],
      p_11601001: 0,
      isCivilError: false,//判断是否有验证不通过的GP 身份信息
      // showCabin:false
      showProductTypeTips: true,
      showFirstProductTypeTips: false,
      showFirstProductTypeColor: '',
      showFirstProductTypeText: '',
      Selfservice: false,
      pickupamout: 0,//接机数量
      dropamout1: 0,//送机数量
      pickupprice: 0,//接机价格
      dropupprice: 0,//送机价格
      pickupetotal: 0,//接机价格合计
      dropofftotal: 0,//送机价格合计
      carpick: '',//接机数据
      cardrop: '',//送机数据
      Variablename: '',//接送机变量名
      filltitle: '',
      submitted: false,
      checkedregist: true,//是否勾选注册会员
      showmember: false, //是否显示会员信息
      HUshow: false,
      tiptext: '订单包括机票、附加选购产品、机建燃油费、税费。点击下一步表示本人已阅读并同意',
      contenttext: '本平台为信息服务平台，具体机票产品及服务（如出票、退改、配送、保险等），由对应航空公司或票务代理机构为您提供',
      springdata: false
    }
  },
  computed: {
    ...mapGetters({
      tkSearchInfo: 'tk/tkSearchInfo',
      travelerList: 'tk/travelerList',
      tripType: 'tripType',
      pageCtrl: 'serviceCtrl', //页面控制信息
      userInfo: 'userInfo',
      sysType: 'sysType',
      loginConfig: 'loginConfig',
    }),
    agreeArr() {
      //协议文本tit
      let arr = []
      if (this.isMU) {
        //如果OPL12东航、上航
        arr = [
          {
            name: '《购票须知》',
            // link: "https://activity.ceair.com/UI/25792TravelGuide/app/pas-ticket-notes.html",
            link: 'https://activity.ceair.com/UI/27845/app/notice.html',
          },
          {
            name: '《旅客须知》',
            link: 'https://activity.ceair.com/UI/25792TravelGuide/app/passengerNotes.html',
          },
          {
            name: '《特殊旅客须知》',
            link: 'https://activity.ceair.com/UI/25792TravelGuide/app/spePaserServe.html',
          },
          {
            name: '《托运危险品说明》',
            link: 'https://activity.ceair.com/UI/25792TravelGuide/app/baggage-restrictions.html',
          },
          {
            name: '《东上航国内国际运输条件》',
            link: 'https://activity.ceair.com/UI/25792TravelGuide/app/second.html?num=48',
          },
        ]
      } else if (this.isCZ) {
        //南航OPL11
        arr = [
          {
            name: '《用户信息安全须知》',
            link: '',
          },
          {
            name: '《锂电池安全运输提示》',
            link: '',
          },
          {
            name: '《旅客、行李国内运输总条件》',
            link: '',
          },
        ]
      } else if (this.isMF) {
        //厦航OPL13
        arr = [
          {
            name: '《隐私通知提示》',
            link: '',
          },
          {
            name: '《用户信息安全须知》',
            link: '',
          },
          {
            name: '《危险品运输规定》',
            link: '',
          },
          {
            name: '《国内运输总条件》',
            link: '',
          },
          {
            name: '《关于新冠肺炎疫情期间乘机出行注意事项的通知》',
            link: '',
          },
        ]
      } else if (this.springdata) {
        //春秋航空
        arr = [
          {
            name: '《旅客须知》',
            // link: "https://activity.ceair.com/UI/25792TravelGuide/app/pas-ticket-notes.html",
            link: 'https://flights.ch.com/notice-travelers',
          },
          {
            name: '《春航运输总条件》',
            link: 'https://flights.ch.com/general-conditions?Time=2022',
          },
          {
            name: '《相关运输说明》',
            link: 'https://flights.ch.com/other-provisions',
          },
          {
            name: '《特殊旅客运输说明》',
            link: 'https://flights.ch.com/special-passenger',
          },
          {
            name: '《机上延误应急预案 》',
            link: 'https://flights.ch.com/Delay-On-Plan/',
          },
          {
            name: '《行李运输须知（含危险品运输》',
            link: 'https://flights.ch.com/notice-baggagetransport',
          },
          {
            name: '《隐私政策》',
            link: 'https://www.ch.com/privacy',
          },
        ]

      } else {
        arr = [
          {
            name: '《机票预订须知》',
            link: '',
          },
          {
            name: '《用户信息安全须知》',
            link: '',
          },
          {
            name: '《锂电池及危险品须知》',
            link: '',
          },
        ]
      }
      if (this.insuranceStrPrice && this.exProArr.length) {
        //如果包含保险
        let arrAy = []
        this.exProArr.forEach((item) => {
          if (item.productId == 25) {
            //保险
            let proObj = {
              name:
                item.productName.indexOf('意外险') != -1
                  ? '《' + item.productName + item.price + '元》'
                  : '《' + item.productName + '》',
              link: '',
            }
            arrAy.push(proObj)
          }
        })
        arr = [...arr, ...arrAy]
      }
      return arr
    },

    serviceFee() {//服务费
      let see = this.tkSearchInfo.flights[0].price.serviceFee - 0 + (this.tkSearchInfo.flights[1] ? this.tkSearchInfo.flights[1].price.serviceFee : 0)
      return see
    },
    // airportFee () {//基建
    // 	let fee = this.tkSearchInfo.flights[0].airportFee - 0 + (this.tkSearchInfo.flights[1] ? this.tkSearchInfo.flights[1].airportFee : 0)
    // 	return fee
    // },
    tax() {//税费
      let tax = this.tkSearchInfo.flights[0].chdTax + (this.tkSearchInfo.flights[1] ? this.tkSearchInfo.flights[1].chdTax : 0)
      return tax
    },
    totalPrice() {//总票价
      if (this.priceList[0]) {
        const adtPrice = this.getPrice(this.priceList, 'adt')
        const chdPrice = this.getPrice(this.priceList, 'chd')
        const Price = this.Price
        let pickupPrice = (this.pickupamout * this.pickupprice) + (this.dropamout1 * this.dropupprice)
        if (this.Selfservice) {
          if (this.filltitle == false) {
            return adtPrice * this.tkSearchInfo.queryStr.aduNum + chdPrice * this.tkSearchInfo.queryStr.chdNum - Price
          }
        }
        return adtPrice * this.tkSearchInfo.queryStr.aduNum + chdPrice * this.tkSearchInfo.queryStr.chdNum - Price + pickupPrice
      }
      // if (this.priceList[0]) {
      // 	return this.priceList[0].price * this.tkSearchInfo.queryStr.aduNum +
      // 		this.priceList[1].price * this.tkSearchInfo.queryStr.chdNum +
      // 		this.priceList[2].price * this.tkSearchInfo.queryStr.infNum
      // }
      return 0
    },
    //接机是否显示
    carpickvuex() {
      return this.$store.state.tk.tkcarpick
    },
    //送机是否显示
    cardropvuex() {
      return this.$store.state.tk.tkcardrop
    },
    flights() {
      return this.tkSearchInfo.flights
    },
  },
  mounted() {
    /*
* 差旅信息 信息回显
* this.tkSearchInfo.ccsqd 出差单详情信息
* this.tkSearchInfo.violate 违背详情信息
* this.$refs.travelinfo.getInfo方法 回显到页面
*/
    if (this.tripType == 1) {
      this.$refs.travelinfo.getInfo({...this.tkSearchInfo.violate, ...this.tkSearchInfo.ccsqd})
    }

  },
  async created() {
    this.init()
    this.querySelfservice()
    this.springaviat()
    if (!this.linker.linkEmail) {
      this.yc = false
    } else {
      this.yc = true
    }

    const data = JSON.parse(localStorage.getItem('userInfo'))
    if (data === null) {
      this.sl = true
      this.agrChecked = true
    } else {
      if (data.vipCorp.corpNo == 'YLCX') {
        this.ysf = true
        this.agrChecked = false
      } else {
        this.sl = true
        this.agrChecked = true

      }
    }
    //判断是否显示海航会员注员航司
    let res = await getParListByCodes('1201')
    let valuobj1 = res[0].value1
    let valuobj2 = res[0].value2.split(",")
    if (valuobj1 == '1') {
      this.HUshow = this.tkSearchInfo.flights.some((item, index) => valuobj2.includes(item.airline))
      if (this.travelerList.length > 0 && this.HUshow) {
        this.huMember()
      }
    }

  },
  methods: {
    springaviat() {//判断是否春秋航空
      let spring = this.tkSearchInfo.flights.some((item) => item.price.productType == 10)
      if (spring) {
        this.springdata = true
      } else {
        this.springdata = false
      }
    },
    // 协议
    clickAgree(item) {
      if (item.link) {
        window.location.assign(item.link)
        return
      }
      this.agreeTit = item.name
      this.agreeShow = !this.agreeShow
    },
    // 获取单人总价
    getPrice(priceList, type) {
      if (!priceList || priceList.length < 1) {
        return 0
      }
      let p = 0,
        cn = 0,
        yq = 0,
        fw = 0,
        yr = 0,
        rt = 0,
        bx = 0
      priceList.forEach(item => {
        if (item.type === type + 'P') {
          p = item.price
        } else if (item.type === type + 'CN') {
          cn = item.price
        } else if (item.type === type + 'YQ') {
          yq = item.price
        } else if (item.type === type + 'FW') {
          fw = item.price
        } else if (item.type === type + 'YR') {
          yr = item.price
        } else if (item.type === type + 'RT') {
          rt = item.price
        } else if (item.type === type + 'BX') {
          bx = item.price
        }
      })
      return p + cn + yq + fw + yr + rt + bx//相加总金额
    },
    async init() {
      this.$api['common/queryVipParameter']({
        paramNo: '11601022'
      }).then(res => {
        let cache = res.data || {}
        this.showProductTypeTips = cache.value1 == 1 ? false : true
        this.showFirstProductTypeTips = cache.value2 == 1 ? true : false
        if (this.showFirstProductTypeTips) {
          this.$api['common/queryVipParameter']({
            paramNo: '11601024'
          }).then(resp => {
            let cacheProduct = resp.data || {}
            this.showFirstProductTypeText = cacheProduct.value2
            this.showFirstProductTypeColor = cacheProduct.value1
          })
        }
      })

      if (this.tkSearchInfo.queryStr.travelType == 2) {
        // let arr = this.tkSearchInfo.queryStr.arriveAirport
        // this.tkSearchInfo.queryStr.arriveAirport = this.tkSearchInfo.queryStr.departAirport
        // this.tkSearchInfo.queryStr.departAirport = arr
        // this.tkSearchInfo.queryStr.departDate = this.tkSearchInfo.queryStr.arriveDate;
        [this.tkSearchInfo.depport, this.tkSearchInfo.arrport] = [this.tkSearchInfo.arrport, this.tkSearchInfo.depport]
      }
      this.linker = {
        linkMan: this.userInfo.empInfo.empName,
        linkTel: this.userInfo.empInfo.phoneNumber,
        linkEmail: this.userInfo.empInfo.email
      }

      // 检查乘机人手机号码是否有重复   系统参数11601001控制是否检查
      let {data = {}} = await this.$api['common/getSysParameter']({
        paramNo: '11601001'
      })
      if (data.value1) this.p_11601001 = data.value1 || '0'
      this.initPrice()
    },
    initPrice() {
      this.initPsgNum()
      let arr = []
      let arr1 = []
      this.flights.map(res => {
        arr.push({
          cacheId: res.cacheId,
          priceId: res.price.priceId,
          rangeList: res.cabinKey //舱位键
        })
        arr1.push({
          cacheId: res.cacheId,
          priceId: res.price.priceId,
          rangeList: res.cabinKey, //舱位键
          flightNo: res.flightNo
        })
      })
      this.cache = arr1
      sessionStorage.setItem('cache', JSON.stringify(arr1))
      this.$api['tkQuery/getAddConPrice']({//动态获取票价
        rangeBeanList: arr,
        tripType: this.tripType
      }).then(res => {
        let cache = res.data || {}
        this.crsf = cache.aduTax
        this.ctsf = cache.chdTax
        this.ticPirce = cache.fcny
        sessionStorage.setItem('cache', JSON.stringify(cache))
        for (let i = 0; i < this.travelerList.length; i++) {
          if (this.travelerList[i].psgType == 1) {
            this.crbx = this.bxPrice
          } else if (this.travelerList[i].psgType == 2) {
            this.ertbx = this.bxPrice
          } else if (this.travelerList[i].psgType != 1) {
            this.crbx = 0
          } else if (this.travelerList[i].psgType != 2) {
            this.ertbx = 0
          }
        }
        // {name:'保险',price:this.details.bxPrice?this.details.bxPrice/cxr.length:0,amount:`/${this.checkBxList.length}份`,unit:''},
        this.priceList = [
          {
            type: 'spliter',
            name: '-------- ' + this.$t('C115', '成人') + ' --------',
            price: null,
            amount: null,
            unit: '',
            show: this.tkSearchInfo.queryStr.aduNum > 0,
            hideYen: this.tkSearchInfo.queryStr.aduNum > 0
          },
          {
            type: 'adtP',
            name: this.$t('C1150', '票面'),
            price: cache.fcny,
            amount: this.tkSearchInfo.queryStr.aduNum,
            unit: '/' + this.$t('E113', '人'),
            show: this.tkSearchInfo.queryStr.aduNum > 0
          }, {
            type: 'adtCN',
            name: this.$t('E102', '机建'),
            price: cache.aduAirportFee,
            amount: this.tkSearchInfo.queryStr.aduNum,
            unit: '/' + this.$t('E113', '人'),
            show: this.tkSearchInfo.queryStr.aduNum > 0
          },
          {
            type: 'adtYQ',
            name: this.$t('E103', '燃油税'),
            price: this.crsf,
            amount: this.tkSearchInfo.queryStr.aduNum,
            unit: '/' + this.$t('E113', '人'),
            show: this.tkSearchInfo.queryStr.aduNum > 0
          },
          {
            type: 'adtFW',
            name: this.$t('E001', '服务费'),
            price: this.serviceFee,
            amount: this.tkSearchInfo.queryStr.aduNum,
            unit: '/' + this.$t('E113', '人'),
            show: this.tkSearchInfo.queryStr.aduNum > 0
          },
          {
            type: 'adtBX',
            name: this.$t('E505', '保险'),
            price: this.crbx,
            amount: `/ ${this.tkSearchInfo.queryStr.aduNum}人`,
            unit: '',
            show: this.crbx > 0 && this.tkSearchInfo.queryStr.aduNum > 0
          },
          {
            type: 'spliter',
            name: '-------- ' + this.$t('C116', '儿童') + ' --------',
            price: null,
            amount: null,
            unit: '',
            show: this.tkSearchInfo.queryStr.chdNum > 0,
            hideYen: true
          }, {
            type: 'chdP',
            name: this.$t('C116', '儿童'),
            price: cache.chdFcny,
            amount: this.tkSearchInfo.queryStr.chdNum,
            unit: this.$t('E113', '人'),
            show: this.tkSearchInfo.queryStr.chdNum > 0
          }, {
            type: 'chdCN',
            name: this.$t('E102', '机建'),
            price: cache.chdAirportFee,
            amount: this.tkSearchInfo.queryStr.chdNum,
            unit: '/' + this.$t('E113', '人'),
            show: this.tkSearchInfo.queryStr.chdNum > 0
          }, {
            type: 'chdRT',
            name: this.$t('E103', '燃油税'),
            price: this.ctsf,
            amount: this.tkSearchInfo.queryStr.chdNum,
            unit: '/' + this.$t('E113', '人'),
            show: this.tkSearchInfo.queryStr.chdNum > 0
          },
          {
            type: 'chdFW',
            name: this.$t('E001', '服务费'),
            price: cache.chdServiceFee,
            amount: this.tkSearchInfo.queryStr.chdNum,
            unit: '/' + this.$t('E113', '人'),
            show: this.tkSearchInfo.queryStr.chdNum > 0
          },
          {
            type: 'chdBX',
            name: this.$t('E505', '保险'),
            price: this.ertbx,
            amount: `/ ${this.tkSearchInfo.queryStr.chdNum}人`,
            unit: '',
            show: this.ertbx > 0 && this.tkSearchInfo.queryStr.chdNum > 0
          },
          //接送机费用
          {
            type: 'spliter',
            name: '-------- ' + "接送机" + ' --------',
            price: null,
            amount: null,
            unit: '',
            show: false, //是否显示
            hideYen: true
          },
          {
            type: 'pick-up',
            name: '接机',
            price: null,
            amount: null,
            unit: '',
            show: false, //是否显示
            hideYen: true
          },
          {
            type: 'drop-off',
            name: '送机',
            price: null,
            amount: null,
            unit: '',
            show: false, //是否显示
            hideYen: true
          },
          // {
          // 	type: 'spliter',
          // 	name: '-------- ' + this.$t('婴儿') + ' --------',
          // 	price: null,
          // 	amount: null,
          // 	unit: '',
          // 	show: this.tkSearchInfo.queryStr.chdNum > 0,
          // 	hideYen: true
          // },
          // {
          // 	type: 'chdYR',
          // 	name: this.$t('C117', '婴儿'),
          // 	price: cache.infFcny + this.airportFee + this.tax + this.serviceFee + this.bxPrice,
          // 	amount: this.tkSearchInfo.queryStr.infNum,
          // 	unit: this.$t('E113', '人'),
          // 	show: this.tkSearchInfo.queryStr.infNum > 0
          // },
          // {
          //   type: 'chdCN',
          //   name: this.$t('E102', '机建'),
          //   price: 0,
          //   amount: this.tkSearchInfo.queryStr.chdNum,
          //   unit: '/' + this.$t('E113', '人'),
          //   show: this.tkSearchInfo.queryStr.chdNum > 0
          // },
          // {
          //   type: 'chdYQ',
          //   name: this.$t('E103', '燃油税'),
          //   price: 0,
          //   amount: this.tkSearchInfo.queryStr.chdNum,
          //   unit: '/' + this.$t('E113', '人'),
          //   show: this.tkSearchInfo.queryStr.chdNum > 0
          // }
        ]
        this.tkSearchInfo.priceList = this.priceList
      }).catch(res => {
        this.queryAgain(res.tips)
      })
    },
    initPsgNum() {
      this.tkSearchInfo.queryStr.aduNum = 0
      this.tkSearchInfo.queryStr.chdNum = 0
      this.tkSearchInfo.queryStr.infNum = 0
      this.travelerList.forEach(item => {
        if (item.psgType == 1 || !item.psgType) {
          this.tkSearchInfo.queryStr.aduNum += 1
        } else if (item.psgType == 2) {
          this.tkSearchInfo.queryStr.chdNum += 1
        } else if (item.psgType == 3) {
          this.tkSearchInfo.queryStr.infNum += 1
        }
      })
    },
    getTavelInfo(info) {// 获取差旅信息
      this.travelInfo = info
    },
    getDecimalLength(arg = '') {
      try {
        if (arg) {
          return arg.toString().split('.')[1].length
        }
      } catch (e) {
        return 0
      }
    },
    getNum(arg = '') {
      if (arg) {
        return Number(arg.toString().replace('.', ''))
      }

    },
    divisionCount(arg1, arg2) {
      let t1, t2
      t1 = this.getDecimalLength(arg1)
      t2 = this.getDecimalLength(arg2)
      if (t1 - t2 > 0) {
        return this.getNum(arg1) / this.getNum(arg2) / Math.pow(10, t1 - t2)
      } else {
        return (this.getNum(arg1) / this.getNum(arg2)) * Math.pow(10, t2 - t1)
      }
    },
    async book() {//提交订单
      var cache_jg = JSON.parse(sessionStorage.getItem('cache'))
      if (this.travelerList.length < 1) {
        this.$toast(this.$t('I001', '请选择出行人'))
        return
      }
      // 联系人不能为空
      if(!this.linker.linkMan || !this.linker.linkTel){
        this.$toast('联系信息不能为空')
        return;
      }
      if (!this.agrChecked) {
        this.$toast('请认真阅读并同意航司相关协议')
        return
      }
      let psgList = this.travelerList.map((item, index) => {
        return {
          empId: item.conempId || item.empId,
          idType: getIdType(item),
          idno: getIdNumber(item),
          phoneNumber: item.phoneNumber,
          psgName: getName(item),
          psgType: item.psgType || '1',
          sex: item.sex,
          born: item.born,
          sn: index + 1,
        }
      })
      console.log('psgList', psgList)
      var st = psgList.filter(item => {
        return item.psgType == '2'
      })
      if (st.length == 0) {

      } else {
        if (cache_jg.chdFcny == '' || '') {
          Dialog.alert({
            title: '温馨提示!',
            message: '该行程不允许预订儿童!',
          }).then(() => {
          })
          return false
        }

      }
      let adultNum = psgList.filter(item => {
        return item.psgType == 1
      })
      let notAdultNum = psgList.filter(item => {
        return item.psgType != 1
      })
      if (adultNum.length == 0) {
        this.$toast('儿童或婴儿不能单独出行，请选择同行成人')
        return
      } else if (notAdultNum.length != 0) {
        let multipleNum = this.divisionCount(notAdultNum.length, adultNum.length)
        if (multipleNum > 2) {
          this.$toast('一名成人最多携带两名儿童或婴儿，请重新选择乘客')
          return
        }
      }
      // psgList.some((item) => {
      // 	if (!item.cardNo) {
      // 		this.$toast('乘机人证件号码不能为空')
      // 	}
      // })
      // if(psgList.some(item => !item.cardNo)){
      // 	this.$toast('乘机人证件号码不能为空')
      // }
      if (this.travelerList.some((item) => (item.cardNo == '' || !item.cardNo))) {
        this.$toast('乘机人证件号码不能为空')
        return
      }
      if (psgList.some(item => !item.phoneNumber)) {
        this.$toast('乘机人手机号不能为空')
        return
      }

      if (psgList.some(item => !validators.telephone(item.phoneNumber).valid)) {
        this.$toast('请填写正确手机号码格式')
        return
      }

      if (this.p_11601001 == '0' && this.checkRepeatPhone(psgList)) {
        this.$toast('乘机人手机号不允许重复，请核对后重新提交')
        return
      }

      if (this.tkSearchInfo.violate && this.tkSearchInfo.violate.canBook === '0') {
        this.$toast('您选择的出行人违背差旅标准，不允许预订，请重新选择。')
        return
      }
      let letter = this.travelerList.some((item) => {
        if (item.cardType == 'NI') {
          //可能是员工或者常旅客，名字不一样要区分下
          let name = item.chName || item.empName
          let letters = /[a-zA-Z]/.test(name);
          if (letters) {
            return true
          }
        }
      })
      if (letter) {
        this.$toast('身份证姓名不支持输入字母,请修改')
        return
      }

      //判断接机送机数据是否完整
      if (this.selfservice && this.filltitle) {
        //接机的判断
        if ((this.carpickvuex.toLocationName == '') && (this.cardropvuex.fromAddress == '')) {
          return this.$toast('请完善接送机信息或取消用车')
        }
        if (this.carpickvuex.toLocationName != '') {
          if (!this.carpickvuex.productI) {
            return this.$toast('请完善接送机信息或取消用车')
          }
        }
        if (this.cardropvuex.fromAddress != '') {
          if (!this.carpickvuex.productId) {
            return this.$toast('请完善接送机信息或取消用车')
          }
          if (this.travelerList.length < this.carpickvuex.carnumber) {
            return this.$toast('用车数量大于用车人，请修改')
          }
        }

      }
      if (this.$route.query.i == 2) {//判断青老年设置
        try {
          let resultso = await this.inspectionelder();
          // 成功逻辑处理
        } catch (error) {

          return
        }
      }
      let bl = this.$refs.travelinfo.result()//判断差旅信息是否填写完整
      if (bl) {
        let num = 0
        let validateTimeOut = () => {
          localStorage.setItem('tkListFilter', JSON.stringify({
            activeV: 2,
            activeFilterNum: 1,
            activeTabArr: [],
          }))
          let element = this.flights[0], obj = {}
          if (element) {
            obj = {
              cacheId: element.cacheId,
              cabinKey: element.cabinKey
            }
            this.$api['tkQuery/validateTimeOut'](obj).then(res => {
              num += (res.errCode - 0)
              if (num == this.flights.length) {
                this.reserved()
              } else {
                validateTimeOut()
              }
            }).catch(res => {
              this.queryAgain(res.tips)
            })
          }
        }
        validateTimeOut()
      }
    },
    inspectionelder() {//开启青老年验证事件
      return new Promise(async (resolve, reject) => {
        let promises = []; //promis数组
        let comprising = this.travelerList.some((item) => {//判断是否有身份证
          return item.cardType == "NI"
        })
        if (comprising) {//有一个身份证进入下方
          for (var i = 0; i < this.travelerList.length; i++) {
            const birthday = this.travelerList[i].cardNo.substr(6, 8)
            const year = birthday.substr(0, 4)
            const month = birthday.substr(4, 2) - 1
            const day = birthday.substr(6, 2)
            const birthDate = new Date(year, month, day)
            const now = new Date()
            let age = now.getFullYear() - birthDate.getFullYear() // 计算年龄
            var _obj = [
              {
                'cacheId': this.cache[0].cacheId,
                'priceId': this.cache[0].priceId,
                'flightNo': this.cache[0].flightNo,
                'cardNo': this.travelerList[i].cardNo,
                'cardType': 'NI',
                'age': age
              }
            ]
            promises.push(this.$api["tkQuery/checkXyhAge"]({datas: _obj}));
          }
          //使用Promise.all来获取循环中调的接口的结果
          Promise.all(promises).then((values) => {
            let results = values.filter((item) => {
              return item.data.resultMsg !== 'SUCCESS'
            })
            if (results.length == 0) {
              resolve()
            } else {
              if (results[0].data.checkResult) {//可下单错误提示
                Dialog.confirm({message: results[0].data.resultMsg})
                  .then(() => {
                    resolve()
                  })
                  .catch(() => {
                    reject()
                  });
              } else {//不可下单错误提示
                Dialog.alert({message: results[0].data.resultMsg}).then(() => {
                  reject()
                });
              }
            }
          });
        }
      });
    },
    reserved() {// 预留票
      //是否有预留改签票
      // 改签预留
      if (!this.travelerList || this.travelerList.length == 0) return
      let arr = []
      this.travelerList.forEach(res => {
        let obj = {
          idNo: getIdNumber(res),
          psgName: getName(res),
          voyage: (this.flights[0].departAirport || this.tkSearchInfo.depport.threeCode || this.tkSearchInfo.depport.departAirport) +
            (this.flights[0].arriveAirport || this.tkSearchInfo.arrport.threeCode || this.tkSearchInfo.arrport.arriveAirport)
        }
        arr.push(obj)
        if (this.flights.length > 1) {
          obj.voyage = (this.flights[1].arriveAirport || this.tkSearchInfo.arrport.threeCode || this.tkSearchInfo.arrport.arriveAirport) +
            (this.flights[1].departAirport || this.tkSearchInfo.depport.threeCode || this.tkSearchInfo.depport.departAirport)
          arr.push(obj)
        }
      })
      var self = this
      this.$api['tkQuery/checkYlgqTkno']({
        psgName: arr
      }).then(res => {
        let cache = res.data || []
        if (cache.length > 0) {
          // 显示
          self.reservedData = cache
          self.showReserved = true
        } else {
          this.sendAjax()
        }
      }).catch(res => {
        // this.$toast(res.tips)
      })
    },
    // 下单
    sendAjax() {
      this.submitted = true
    },
    //乘积人信息确认按据
    buttconfirmed() {
      this.submitted = false
      let bxcpList = this.$refs.insurance.getInsurance()
      if (!this.showmember) {
        this.checkedregist = false
      }
      let HuMember
      this.checkedregist ? HuMember = "1" : HuMember = "0"
      let obj = {
        registerHuMember: HuMember,
        ccsqdId: this.travelInfo.ccsqdId,
        ccsqdNo: this.travelInfo.ccsqdNo,//出差单号
        ccsqdRemark: this.travelInfo.ccsy || this.travelInfo.ccsqdRemark || '',
        costCenterCode: this.travelInfo.costCenterCode,
        costCenterId: this.travelInfo.costCenterId,
        costCenterName: this.travelInfo.costCenterName,
        subjectCode: this.travelInfo.subjectCode,//科目码
        projectCode: this.travelInfo.projectCode,
        projectId: this.travelInfo.projectId || this.travelInfo.id,
        projectName: this.travelInfo.projectName,
        empRank: this.tkSearchInfo.empRank,
        linkEmail: this.linker.linkEmail,
        linkMan: this.linker.linkMan,
        linkTel: this.linker.linkTel,
        orderFrom: getSysType(),//this.orderfrom,
        postCode: '', //邮编
        rangeType: (this.tkSearchInfo.roundtrip > 0 ? 2 : 1) || 1,
        reciAddr: '', //收件地址
        reciPhone: '',
        reciPient: '', //收件人
        routeId: this.tkSearchInfo.voyage.routeId, //行程ID
        sendMode: 1, //公司统一配送
        supplierId: this.flights[0].price.supplierId, //供应商id
        travelNo: '', //出差申请单号
        travelStandard: this.tkSearchInfo.queryStr.empRank, //标准差标等级
        tripType: this.tkSearchInfo.queryStr.tripType, //因公因私
        psgList: this.travelerList.map((item, index) => {
          console.log(item, '00')
          var obj = {
            // empId: item.conempId||item.personId||item.contactsId||item.empId,//顺序不能变
            /**
             * 只要是员工id 传过来就可以了
             * 不要传personId 也不要传常旅客id, 后台不支持
             */
            empId: item.conempId || item.empId,
            idType: getIdType(item),
            idno: getIdNumber(item),
            phoneNumber: item.phoneNumber,
            psgName: getName(item),
            psgType: item.psgType || '1',
            sex: item.sex,
            born: item.born,
            sn: index + 1,
            isCivil: item.isCivil,
            nation: item.nation,
            passportPeriod: item.passportPeriod,
          }
          if (this.pageCtrl.isCivil == 1) {
            if (this.tkSearchInfo.queryStr.showGpProduct) {
              Object.assign(obj, {
                civilCheck: item.civilCheck || '',
                civilBankId: item.civilBankId || '',
                civilBankName: item.civilBankName || '',
                unitAddress: item.unitAddress || '',
              })
              if (item.isCivilError) {
                this.isCivilError = true
              }
            }
          }
          return obj
        }),
        rangeList: this.flights.map((item) => {
          return {
            cacheId: item.cacheId,
            priceId: item.price.priceId,
            rangeList: item.cabinKey,
            reasonCode: this.travelInfo.reasonCode,//违背规则code
            reasonDesc: this.travelInfo.reasonDesc//违背原因
          }
        }),
        bxcpList: bxcpList,
        minPriceRemark: this.$store.state.tk.selectreason, //验价原因显示不选择最低价的原因
        minFlightRemark: this.$store.state.tk.minFlightRemark, //列表原因
      }

      if (this.tkSearchInfo.queryStr.showGpProduct) {
        let bool = false
        obj.psgList.forEach(item => {
          if (!item.isCivil) {
            bool = true
          }
        })
        if (bool) {
          this.$dialog.alert({
            title: '提示',
            message: '已开启公务员订票，请完整填写公务员购票信息！'
          })
          return
        }

        obj.psgList.forEach(item => {
          delete item.isCivil
        })

        if(this.flights[0].price.productType != '7'){

          this.$dialog.confirm({
            title: '提示',
            message: '您预订的为非政采票，请确认是否继续下单？'
          }).then(() => {
            this.bookOrder(obj)
          }).catch(() => {
            //返回上一页
            this.$router.back()
          })
        }else if (this.isCivilError) {
          this.$dialog.confirm({
            title: '提示',
            message: '公务员身份验证不通过，可能导致出票失败，请确认是否继续下单？'
          }).then(() => {
            this.bookOrder(obj)
          }).catch(() => {

          })
        } else {
          this.bookOrder(obj)
        }
      } else {
        obj.psgList.forEach(item => {
          delete item.isCivil
        })
        this.bookOrder(obj)
      }
    },
    //用车下单
    carsendAjax(res) {
      return new Promise(async (resolve, reject) => {
        let associated = res.orderList[0]
        let arr = [
          {
            cacheId: this.carpick.cacheId,//会报请求标志不能为空
            departAirport: this.carpick.departAirport,
            departAirportName: this.carpick.departAirportName,
            departTerminal: '', //// 出发航站楼
            departTime: this.carpick.useTime, //航班出发时间(胡)
            arriveAirport: this.carpick.useAirportOrZd,//机场三字码
            // arriveAirportName:this.carSearchInfo.arriveAirportName,
            arriveTerminal: '',//到达航站楼
            arriveTime: this.carpick.useTime, //航班到达时间
            flightNo: this.carpick.flightNo,
            departCity: this.carpick.departCity, //用车城市id
            arriveCity: this.carpick.arriveCity,
            fromLat: this.carpick.fromLat, // 出发纬度
            fromLon: this.carpick.fromLon,
            toLat: this.carpick.toLat, //到达纬度
            toLon: this.carpick.toLon,
            toArea: '',// 到达区域，存城市行政区
            toAddress: this.carpick.toAddress, //: 下车地点
            toAddressPoi: this.carpick.toLocationName,
            fromArea: '',//	// 出发区域，存城市行政区
            fromAddress: this.carpick.fromAddress, //上车地点
            fromAddressPoi: this.carpick.fromLocationName,
            startTime: this.carpick.useTime, //用车时间
            // rangeType: '1', // 用车范围1市内/2郊区出城 ,
            useType: '4', //4接机
            orderFrom: this.sysType, //订单来源
            productId: this.carpick.productId,
            linkman: this.carpick.customerName,
            linkTel: this.carpick.customerMobile,
            unionOrderId: associated.orderId,
            pnrNo: associated.pnrNo,
            unionOrderType: '10901',
            tripType: null,//出行类型1因公2因私
            ccsqdId: '',//出差申请单id
            ccsqdNo: ''//出差申请单单号
          },
          {
            cacheId: this.cardrop.cacheId,//会报请求标志不能为空
            departAirport: this.cardrop.departAirport,
            departAirportName: this.cardrop.departAirportName,
            departTerminal: '', //// 出发航站楼
            departTime: this.cardrop.useTime, //航班出发时间(胡)
            arriveAirport: this.cardrop.useAirportOrZd,//机场三字码
            // arriveAirportName:this.carSearchInfo.arriveAirportName,
            arriveTerminal: '',//到达航站楼
            arriveTime: this.cardrop.useTime, //航班到达时间
            flightNo: this.cardrop.flightNo,
            departCity: this.cardrop.departCity, //用车城市id
            arriveCity: this.cardrop.arriveCity,
            fromLat: this.cardrop.fromLat, // 出发纬度
            fromLon: this.cardrop.fromLon,
            toLat: this.cardrop.toLat, //到达纬度
            toLon: this.cardrop.toLon,
            toArea: '',// 到达区域，存城市行政区
            toAddress: this.cardrop.toAddress, //: 下车地点
            toAddressPoi: this.cardrop.toLocationName,
            fromArea: '',//	// 出发区域，存城市行政区
            fromAddress: this.cardrop.fromAddress, //上车地点
            fromAddressPoi: this.cardrop.fromLocationName,
            startTime: this.cardrop.useTime, //用车时间
            // rangeType: '1', // 用车范围1市内/2郊区出城 ,
            useType: '5', //4接机
            orderFrom: this.sysType, //订单来源
            productId: this.cardrop.productId,
            linkman: this.cardrop.customerName,
            linkTel: this.cardrop.customerMobile,
            unionOrderId: associated.orderId,
            pnrNo: associated.pnrNo,
            unionOrderType: '10901',
            tripType: null,//出行类型1因公2因私
            ccsqdId: '',//出差申请单id
            ccsqdNo: ''//出差申请单单号
          }
        ]
        //循利用车数量下单次数
        //循环次数=接机+送机
        let promises = []; //promis数组
        if (this.pickupetotal > 0) {//接机
          for (let i = 0; i < this.carpick.carnumber; i++) {
            //用车人信息
            let list = this.travelerList[i]
            let pick = {}
            pick.empName = list.chName || list.empName //出行人姓名
            pick.empId = list.conempId || list.empId //出行人id
            pick.phoneNumber = list.phoneNumber

            let obj = Object.assign(arr[0], pick)
            obj.tripType = res.tripType
            obj.ccsqdId = res.ccsqdId
            obj.ccsqdNo = res.ccsqdNo
            console.log('obj是个什么东西', obj)
            // promises.push(this.$api['carQuery/bookYyyc'](obj))
            promises.push(obj)
          }
        }
        if (this.dropofftotal > 0) {//送机
          //    time=time+this.cardrop.carnumber
          for (let i = 0; i < this.cardrop.carnumber; i++) {
            let list = this.travelerList[i]
            let pick = {}
            pick.empName = list.chName || list.empName //出行人姓名
            pick.empId = list.conempId || list.empId //出行人id
            pick.phoneNumber = list.phoneNumber
            let obj = Object.assign(arr[1], pick)
            obj.tripType = res.tripType
            obj.ccsqdId = res.ccsqdId
            obj.ccsqdNo = res.ccsqdNo
            // promises.push(this.$api['carQuery/bookYyyc'](obj))
            promises.push(obj)
          }
        }

        this.$api['carQuery/bookYyycs']({
          'vehiclesReq': [...promises]
        }).then(res => {
          resolve()
        }).catch(err => {
          console.log('下单结果err', err)
          reject()
        })
        //通过Promise.all来获取循环中调的接口的结果

        // Promise.all(promises).then((res)=>{
        //   console.log("获取结果res",res)
        //   resolve()
        // }).catch((err)=>{
        // 	console.log("获取结果err",err)
        // 	reject()
        // })

      })

    },
    async bookOrder(obj) {
      let cache = null
      await this.$api['tkQuery/bookOrder'](obj).then(res => {
        cache = res.data || {}
      }).catch(res => {
        if((res.errCode!=102 && res.errCode!=999 && res.errCode!=998)){this.$toast(res.tips)}
      })
      let cacheOrder = cache.orderList[0] || ''
      //调取用车的接口
      if (this.Selfservice) {//接机和送机要选择有金额
        if (this.filltitle) {
          if (this.pickupetotal || this.dropofftotal) {
            try {
              cache.tripType = obj.tripType
              cache.ccsqdId = obj.ccsqdId
              cache.ccsqdNo = obj.ccsqdNo
              await this.carsendAjax(cache)
            } catch (err) {
              return
            }
          }
        }
      }

      // 用户提交订单是否自动送审（1：是；0：否；）
      let p_20023 = false
      let {data = {}} = await this.$api['common/queryParameter']({'paramNos': '20023'})
      if (data && data.parameterResponses && data.parameterResponses[0] && data.parameterResponses[0].value1) {
        p_20023 = data.parameterResponses[0].value1 === '1'
      }

      // orderStatus == '1' 为已申请状态
      // 状态见 oss-ui /src/main/webapp/js/staticData.js
      // 已申请状态的订单不给与送审
      const isOrderApplyStatus = cacheOrder.orderStatus === '1'

      //超标的后审订单进行送审提交以及审核
      if ((obj.rangeList[0].reasonCode && this.tkSearchInfo.ccsqd.auditType === 1 || p_20023) && !isOrderApplyStatus) {
        var params = {
          orderId: cacheOrder.orderId,
          orderType: '11001',
          orderNo: cacheOrder.orderNo
        }

        //审批规则
        let {data = []} = await this.$api['approval/orderApproveList'](params)
        if (data.length > 0) {
          var currOrder = data[0]
          var spgz = currOrder.vipSpgzGetInfo
          var gznr = spgz.gznr[0]
          var spEmp = gznr.empList[0]
          //优先取有OAADMIN审批的员工信息
          for (let gz of spgz.gznr) {
            for (let emp of gz.empList) {
              if (emp.empNo == 'OAADMIN') {
                gznr = gz
                spEmp = emp
              }
            }
          }

          var sendAppParams = {
            orderId: cacheOrder.orderId,
            orderType: '11001',
            orderNo: cacheOrder.orderNo,
            spgzId: spgz.gzid,
            vipBpmPersonnels: [
              {
                empId: spEmp.empId,
                empName: spEmp.empName,
                gzid: spgz.gzid,
                jblx: spEmp.jblx || 0,
                spjb: gznr.level
              }
            ]
          }
          //送审
          await this.$api['approval/vipBpmSendAppNew'](sendAppParams)
          if (this.tkSearchInfo.ccsqd.auditType === 1) {
            //查询审批中订单
            let workItemId = ''
            await this.$api['approval/vipBpmForMyAppNew']({
              approveType: 1,
              count: 50
            }).then(res => {
              let approvingList = res.data.list[0].vipBpmForMyAppDtoList
              for (let approve of approvingList) {
                if (approve.orderId == cacheOrder.orderId) {
                  workItemId = approve.workItemId
                  break
                }
              }
            })
            if (workItemId) {
              //审批订单
              let receiveAppParams = {
                appRemark: '',
                completeState: 1,
                completeWay: 2,
                workItemId
              }
              await this.$api['approval/vipBpmReceiveAppResult'](receiveAppParams)
            }
          }
          if (p_20023) {
            await this.$router.push({path: '/allOrder?findType=1'})
          }
        }
      }
      this.jump(cache)
    },
    jump(cache) {
      if (cache.orderList.length > 1) {
        this.$dialog({
          confirmButtonText: '前往',
          message: '系统生成两个订单前往订单列表查看',
        }).then(() => {
          this.$router.push({
            path: '/allOrder?findType=1',
            query: {findType: 1, productType: '10901'}
          })
        })
      } else {
        if (isGat()) {
          return this.$router.replace({
            path: '/tk/tkCmp',
            query: {
              orderId: cache.orderList[0].orderId, priceFlag: cache.priceFlag, msg: cache.msg, ertbx: this.bxPrice,
              crbx: this.bxPrice,
            }
          })
        }
        this.$router.push({
          path: '/tk/tkCmp',
          query: {
            orderId: cache.orderList[0].orderId, priceFlag: cache.priceFlag, msg: cache.msg, ertbx: this.bxPrice,
            crbx: this.bxPrice,
          }
        })
      }
    },
    queryAgain(tips) {
      this.$dialog.confirm({
        title: this.$t('C474', '提示'),
        message: tips,
        confirmButtonText: this.$t('B061', '重新查询')
      }).then(() => {
        // on confirm
        let arriveAirport = this.tkSearchInfo.queryStr.arriveAirport
        let departAirport = this.tkSearchInfo.queryStr.departAirport
        this.tkSearchInfo.queryStr.arriveAirport = arriveAirport
        this.tkSearchInfo.queryStr.departAirport = departAirport
        // this.tkSearchInfo.roundtrip = 0
        this.tkSearchInfo.flights = []
        this.tkSearchInfo.queryStr.departDate = this.tkSearchInfo.departDate.date
        // this.$router.go(-1)
        this.$router.replace({path: '/tk/tkQuery', query: {}})
      }).catch(() => {
        // on cancel
      })
    },
    getLinker(info) {//修改联系人回调
      this.linker = {}
      this.linker = info
      if (info.linkEmail == '') {
        this.yc = false
      } else {
        this.yc = true
      }
    },
    toggle(ref, info) {
      if (info) {//退改规则参数
        this.changeRule = {
          'cacheId': info.cacheId,
          'flightNo': info.flightNo,
          'cabin': info.cabin.cabin,
          'priceId': info.price.priceId,
        }
      }
      this.$refs[ref].toggle(info)
    },
    getClbz() {
      if (this.pageCtrl.isShowCxr) {//判断是否需要获取差标
        this.$store.commit('SET_SERVICE', {cplx: '10901'})
        let clbz = this.pageCtrl.getClbzMinZj(this.travelerList)
        this.tkSearchInfo.minzj = clbz.minzj//最低差标等级
        this.tkSearchInfo.minzjName = clbz.minzjName//最低差标等级
        let str = {
          arriveAirport: this.tkSearchInfo.arrport.threeCode,
          departAirport: this.tkSearchInfo.depport.threeCode,
          empRank: this.tkSearchInfo.minzj,
          cplx: '10901'
        }
        if (!str.arriveAirport || !str.departAirport || !this.travelerList || this.travelerList.length < 1) {
          return
        }
        try {
          this.$api['tkQuery/GetClzbByMinZj'](str)
            .then(res => {
              let cache = res.data || {}
              if (cache.clbz) {
                if (this.tkSearchInfo.clbzTitle != cache.clbz) {
                  console.log("this.tkSearchInfo.clbzTitle != cache.clbz", this.tkSearchInfo.clbzTitle != cache.clbz)
                  console.log("this.tkSearchInfo.clbzTitle", this.tkSearchInfo.clbzTitle)
                  console.log(" cache.clbz", cache.clbz)
                  this.tkSearchInfo.clbzTitle = cache.clbz
                  this.matchClbz()
                }
              } else {
                this.tkSearchInfo.clbzTitle = ''
                this.tkSearchInfo.violate = {}
                this.tkSearchInfo.violateList = []
              }
            })
        } catch (error) {
        }
      }
    },
    // 获取是否违背
    matchClbz() {
      this.$api['tkQuery/matchClbz']({
        'cacheId': this.tkSearchInfo.flights[0].cacheId,
        'minZj': this.tkSearchInfo.minzj,
        'routeId': this.tkSearchInfo.voyage ? this.tkSearchInfo.voyage.routeId : '',
        'ccsqdId': this.tkSearchInfo.ccsqd.ccsqdId,
        'auditType': this.tkSearchInfo.ccsqd.auditType,
      }).then(res => {
        let cache = res.data || {}
        let priceId = this.tkSearchInfo.flights[0].price.priceId
        this.tkSearchInfo.violateList = cache
        if (cache[priceId]) {
          Object.assign(this.tkSearchInfo.violate, cache[priceId])
          this.$refs.travelinfo.getInfo({...this.tkSearchInfo.violate})
        } else {
          this.tkSearchInfo.violate = {}
          this.tkSearchInfo.violateList = []
        }
      })
    },
    checkBxList(val) {
      if (val && val.length > 1) {
        this.bxPrice = 0
        val.forEach((accumulator) => {
          this.bxPrice += accumulator.saleprice
        })
      } else if (val && val.length == 1) {
        this.bxPrice = val[0].saleprice
      } else {
        this.bxPrice = 0
      }
      this.initPrice()
    },
    checkRepeatPhone(psgList) {
      var o = {},
        isRepeat = false

      psgList.forEach(function (psg) {
        if (psg.psgType == 1) {
          if (o[psg.phoneNumber]) {
            isRepeat = true
          } else {
            o[psg.phoneNumber] = true
          }
        }
      })

      return isRepeat
    },
    //获取根据20034数值，获取是否可自选航航班
    async querySelfservice() {
      await getParameter('20035').then(res => {
        if (res.value1 == 1) {
          this.Selfservice = true
          this.tiptext = '我已确认乘客信息，已认真阅读并同意遵守'
          this.contenttext = '及退改签规则。'
        } else {
          this.Selfservice = false
        }
      })
    },

    //用车的数量与金额
    carnumber(ber, num) {
      if (ber.salePrice) {//传的是价格
        num == 0 ? this.pickupprice = ber.salePrice : this.dropupprice = ber.salePrice
      } else {//传的是数量
        num == 0 ? this.pickupamout = Number(ber) : this.dropamout1 = Number(ber)
      }
      let pickup = this.pickupamout * this.pickupprice
      let dropoff = this.dropamout1 * this.dropupprice
      this.pickupetotal = pickup
      this.dropofftotal = dropoff
      console.log('this.pricelis', this.priceList)
      this.priceList.forEach((item, index) => {
        if (pickup > 0 || dropoff > 0) {
          if (item.name == '-------- ' + "接送机" + ' --------' && item.show == false) {
            item.show = true
          }
        }
        if (item.name == '接机') {
          if (pickup > 0) {
            item.show = true
            item.price = `￥${this.pickupprice}`
            item.amount = `${this.pickupamout}/辆`
          } else {
            item.show = false
          }
        }
        if (item.name == '送机') {
          if (dropoff > 0) {
            item.show = true
            item.price = `￥${this.dropupprice}`
            item.amount = `${this.dropamout1}/辆`
          } else {
            item.show = false
          }
        }
      })
    },
    //
    picksenddaea(pick, drop) {//接送机数据
      this.carpick = pick
      this.cardrop = drop
    },
    fillshow(item) {
      // consoel.log("传过来的值",item)
      this.filltitle = item
    },
    async huMember() { //航海会员构选框是否显示
      let obj = []
      this.travelerList.map((item, index) => {
        obj.push(
          {
            // empId: item.conempId||item.personId||item.contactsId||item.empId,//顺序不能变
            /**
             * 只要是员工id 传过来就可以了
             * 不要传personId 也不要传常旅客id, 后台不支持
             */
            empId: item.conempId || item.empId,
            idType: getIdType(item),
            idno: getIdNumber(item),
            phoneNumber: item.phoneNumber,
            psgName: getName(item),
            psgType: item.psgType || '1',
            sex: item.sex,
            born: item.born,
            sn: index + 1,
            // isCivil: item.isCivil,
            nation: item.nation,
            passportPeriod: item.passportPeriod,
          }
        )
      })
      let prerm = {
        psgList: [...obj]
      }
      await this.$api['tkQuery/huMemberCheckByPsg'](prerm).then(res => {
        let code = res.data.code || {}
        code == 1 ? this.showmember = true : this.showmember = false;
      }).catch(res => {
        if(res.errCode && res.errCode==102 && res.errCode==999 && res.errCode==998){
          return
        }
        this.$toast(res.tips)
      })
    },
  },
  watch: {
    'travelerList.length'() {
      this.initPrice()
      this.getClbz()
      if (this.travelerList.length > 0 && this.HUshow) {
        this.huMember()
      }
    }
  }
}

</script>

<style lang="less" scoped>
@import '~Assets/styles/business';

.pad-r-8 {
  padding-right: 8px;
}

.pad-lr-16 {
  padding-left: 16px;
  padding-right: 16px;
}

.pad-b-20 {
  padding-bottom: 20px;
}

.borderRadius {
  border-radius: 4px;
}

.pad-b-20 {
  padding-bottom: 20px;
}

.agreementBox {
  margin: 0 0 12px 0;
  border-top: 1px solid #eee;
  line-height: 15px;
}

.ft-12 {
  font-size: 12px !important;
  //   width: 330px;
  //   position: relative;
  right: -25px;
}

.checkClass {
  //   width: 16px;
  //   top: 15px;
  //   position: relative;
  //   left: 5px;
  margin: 5px;
}

.tkEdit {

  .box {
    padding: 0 6px;


    > div {
      margin-bottom: 5px;
    }

    .plane {
      height: 1.2rem;
    }
  }

  .FF {
    background: #fff;
    color: #000;
    // height: 120px;
    display: flex;
    padding-top: 12px;
    padding-bottom: 10px;
  }

  .tkEditwrapper {
    height: calc(100vh - 96px);
    overflow: hidden;
  }

  .text-indent {
    text-indent: 20px;
  }
}

.colorBlue {
  color: #0f7ffa;
}

.colorCustomized,
.colorCustomizedLight {
  color: #1863ed !important;
}

.diflx {
  display: flex;
  justify-content: space-between
}

.diflx_font {
  color: #eb6100;
  font-size: 13px;
}

.diflx_font2 {
  color: #3D93D1;
  font-size: 13px;
}

.diflx_mat {
  display: flex;
  justify-content: center;
  margin-top: 8px;
}

/deep/ .van-cell__right-icon {
  color: #3D93D1
}

.ellipsis {
  width: 169px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.contact-info {
  padding: 14px;
}

.no-padding .van-cell {
  padding: 0 !important;
}

.no-padding {
  padding: 0 !important;
}

.custom_dialog {
  max-height: 85%;
  border-radius: 10px;
}

.custom_css {
  position: relative;
  display: flex;
  box-sizing: border-box;
  width: 100%;
  /* padding: 10px 16px; */
  overflow: hidden;
  color: #616161;
  font-size: 14px;
  // line-height: 24px;
  background-color: #fff;
  margin-bottom: 5px
}

.color-bar {
	flex: 1;
  height: 2px; /* 设置横条高度 */
//   background: repeating-linear-gradient(
//     to right,
//     #FFAF3E,
//     #FFAF3E 5px,
//     #ffff 5px,
//     #ffff 10px

  margin-bottom: 5px;
}

color-bar::before {
  content: "";
  position: absolute;
  top: 50%; /* 将线置于外盒子中间位置 */
  left: 0;
  right: 0;
  border-top: 1px solid black; /* 设置线条样式 */
}

.custom_tili {
  // font-weight: 600;
  // font-weight: bold;
  display: inline-block;
  margin-right: 4px;
}

.button_css {
  width: 100%;

  display: flex;
  justify-content: end;
  align-content: center;
  margin-bottom: 10px;
  position: sticky;
  bottom: 10px;
  background-color: #ffff;
}

.button_height {
  height: 38px !important;
  // background-color:@color-text-white;
  border: 0px;
}

/deep/ .van-dialog__content {
  overflow-y: auto;
  max-height: 500px;
}

.marg_bott {
  margin-bottom: 4px;
}

.tilti_info {
  color: #AAAAAA;
  margin-bottom: 5px;
  font-size: 14px;
}

.color-bartow {
  flex: 1;
  height: 3px;
  margin-bottom: 5px;
  z-index: 500;
  width: 576px;
  position: relative;
  overflow: overlay;
  background-image: radial-gradient(circle, #AAAAAA 1px, transparent 1px);
  background-size: 5px 1px;
}

.h4title {
  margin: 0
}

.font11c {
  font-size: 11px;
  color: #8e8e8e
}

.marin_4px {
  margin-left: 18px;
  line-height: 1.7;
}

van-cell .pad_0 {
  padding-bottom: 2px;
}
.marg_left{

}
.font_left{
    color: #45bf9b;
    font-weight: bold;
    margin-left: 20px;
}
</style>
